import React, { useState, useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext'; 
import "./Canvas.css";

let Canvas = () => {
	const { 
		colors, 
		gradient, 
		textArray, 
		handleTextArray, 
		theme, 
		themes, 
		template } = useContext(AppContext);
		
	const [templateBackground, setTemplateBackground] = useState();
	
	useEffect(() => {
		loadCSS(themes[theme].specs.css);
	},[theme]);
	
	useEffect(() => {
		handleBackground(colors);
	}, [colors, gradient]);
	
	let handleBackground = (clrs) => {
		if (themes[theme].templates[template].colors) {
			let _style = themes[theme].templates[template].colors.length === 1 ? 
				{ backgroundColor: `${clrs[0]}`} : 
				{ backgroundImage: `linear-gradient(${themes[theme].templates[template].bg || 145}deg, ${clrs[0]} ${ !gradient ? '50%' : ''}, ${clrs[1]} ${ !gradient ? '50%' : ''})`}
			setTemplateBackground(_style);
		}
	}
	let loadCSS = (filename) => {
        let fileref = document.createElement("link");
        	fileref.setAttribute("rel", "stylesheet");
        	fileref.setAttribute("type", "text/css");
        	fileref.setAttribute("href", "/themes/" + filename);
			fileref.setAttribute("id", "CanvasStyles");
		if (!document.getElementById("CanvasStyles")) {
			document.body.append(fileref);
		} else {
			document.getElementById("CanvasStyles").setAttribute("href", "/themes/" + filename);
		}
	}

	return (
		<div class={`CanvasWrapper ${themes[theme].target}__${themes[theme].templates[template].css}`}>
			<div id="Canvas" class={`Canvas`}>
				<div class="_wrapper">
					{ themes[theme].templates[template].text &&
						<>					
							{ [... textArray || []].map( (str, i) => 
								<h1 key={i}>
									<span 
										onBlur={ (e) => handleTextArray(e, i, e.target.innerHTML)  } 
										contentEditable class="Editable" 
										dangerouslySetInnerHTML={{__html: str}} />
								</h1>
							)}
						</>
					}
				</div>
				<div class="Canvas__bg" style={ templateBackground }></div>
			</div>
			<div class="Canvas__desc">{ themes[theme].specs.width } x { themes[theme].templates[template].height || themes[theme].specs.height }</div>
		</div>
	)
}

export default Canvas;